const TeamDetail = ({ fixture, id }) => {
	const homeTeam =
		fixture?.competitor?.[fixture?.competitor?.[0]?.isHome ? 0 : 1];
	const awayTeam =
		fixture?.competitor?.[fixture?.competitor?.[1]?.isHome ? 0 : 1];

	const homeLogo =
		homeTeam?.team?.logo?.url || homeTeam?.team?.club?.logo?.url || null;
	const awayLogo =
		awayTeam?.team?.logo?.url || awayTeam?.team?.club?.logo?.url || null;

	return (
		<div className='team-details'>
			{id === '0' ? (
				homeLogo ? (
					<div className='team-logo'>
						<img src={homeLogo} alt={homeTeam?.team.nameFull} />
					</div>
				) : (
					<span className='team-name'>{homeTeam?.team?.code}</span>
				)
			) : awayLogo ? (
				<div className='team-logo'>
					<img src={awayLogo} alt={awayTeam?.team.nameFull} />
				</div>
			) : (
				<span className='team-name'>{awayTeam?.team?.code}</span>
			)}
		</div>
	);
};

export default TeamDetail;
